import React from "react";
import styled from "styled-components";
import Button from "../Button/button";
import { Link } from "gatsby";
import Data from "../../utils/data";
import { GatsbyImage } from "gatsby-plugin-image";
import { Logo } from "../../assets/svg";

const FooterSection = styled.footer<{ background?: boolean }>`
  background-color: ${(props) =>
    props.background ? "#F9FDFF" : "transparent"};
`;
const ButtonSection = styled.div`
  display: flex;
  justify-content: center;
  a {
    margin-right: 20px;
  }
  @media (max-width: 575px) {
    flex-direction: column;
    a {
      margin-right: 0;
    }
  }
  button {
    @media (max-width: 575px) {
      width: 60% !important;
      font-size: 14px;
      margin: 13px 0px 0px 0px;
    }
  }
`;
const FooterRights = styled.div`
  a {
    text-decoration: none;
    font-size: 16px;
    line-height: 20px;
    color: #676767;
    p{
      margin-bottom: 0;
    }
    p:hover {
      color: #1da1f2 !important;
    }
  }
  span {
    color: rgb(103, 103, 103);
    font-size: 16px;
    
  }
  text-align: center;
  @media (max-width: 1200px) {
    font-size: 10px;
    align-items: center;
  }

  @media (max-width: 575px) {
    flex-direction: column;
    margin-top: 14px;
    line-height: 2;
    padding: 0px 36px;
    span {
      font-size: 14px;
    }
    a{
      font-size: 14px;
    }
  
  }

`;
const PaymentIcons = styled.div`
  @media (max-width: 575px) {
    svg {
      width: 38px;
    }
  }
`;
const BtnDiv = styled.div`
  padding-bottom: 70px;
  text-align: center;
`;

const FooterWrapper = styled.div`
  @media (max-width: 575px) {
    display: flex;
    flex-direction: column-reverse;
  }
`;

interface Props {
  background?: boolean;
}

const Footer = ({ background }: Props) => {
  const strapiGlobal = Data();

  const { copyRightText, bottomDescription, payment } =
    strapiGlobal.strapiLayout.footer;

  return (
    <FooterSection background={background}>
      <div className="container pb-3">
        <BtnDiv>
          <div className="d-flex flex-column align-items-center pb-5 pt-5">
            <Logo />
          </div>
          <ButtonSection>
            <Link to="/buy-instagram-views?service=view">
              <Button text={"Buy view"} style={{ padding: "6px 30px" }}  />
            </Link>
            <Link to="/buy-instagram-followers?service=followers">
              <Button text={"Buy follower"} style={{ padding: "6px 30px" }} />
            </Link>
            <Link to="/buy-instagram-likes?service=like">
              <Button text={"Buy likes"} style={{ padding: "6px 30px" }} />
            </Link>
          </ButtonSection>
        </BtnDiv>

        <FooterWrapper className="row ">
          <div className="col-sm-12 col-md-6 mb-3">
            <FooterRights className="d-flex">
              <span>{copyRightText}</span>
              <div className="d-flex">
                {bottomDescription.map((item: any, index: number) => {
                  return (
                    <Link to={item.footerBarLink} key={index} className="ms-1">
                      <p
                        style={{
                          marginTop: "3px",
                          color: "#212529",
                          textTransform: "capitalize",
                        }}
                      >
                        <span
                          style={{
                            marginLeft: "2px",
                            marginRight: "4px",
                          }}
                        >
                          |
                        </span>
                        {item.footerBarText}
                      </p>
                    </Link>
                  );
                })}
              </div>
            </FooterRights>
          </div>
          <div className="col-sm-12 col-md-6 text-right">
            <PaymentIcons className="d-flex justify-content-center justify-content-md-end mb-3">
              {payment.map((item: any, index: number) => {
                return (
                  <div className="px-1 px-md-2" key={index}>
                    <GatsbyImage
                      alt={"payment card"}
                      image={
                        item.cardImage.localFile.childImageSharp.gatsbyImageData
                      }
                    />
                  </div>
                );
              })}
            </PaymentIcons>
          </div>
        </FooterWrapper>
      </div>
    </FooterSection>
  );
};

export default Footer;